import { useEffect, useState } from 'react'

/**
 * iOS gives no install prompt, so the only way onto the home screen is Share,
 * then Add to Home Screen. This says so once, on the device where it applies,
 * and never again after he dismisses it.
 *
 * It matters more than it looks: web push on iOS only works from the home
 * screen icon, never from a Safari tab.
 */
const KEY = 'mpos.install-hint'

export default function InstallHint() {
  const [show, setShow] = useState(false)

  useEffect(() => {
    const standalone =
      window.matchMedia?.('(display-mode: standalone)').matches ||
      window.navigator.standalone === true
    if (standalone) return

    const ua = navigator.userAgent
    const isIOS = /iPhone|iPad|iPod/.test(ua) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
    if (!isIOS) return

    try {
      if (localStorage.getItem(KEY) === 'done') return
    } catch {
      /* blocked storage just means it shows again; harmless */
    }
    setShow(true)
  }, [])

  if (!show) return null

  return (
    <div className="install-hint" role="note">
      <div>
        <span className="lbl">Put it on your home screen</span>
        <p>
          Tap Share, then <b>Add to Home Screen</b>. Opening it from the icon is also the only
          way reminders can reach you.
        </p>
      </div>
      <button
        type="button"
        aria-label="Dismiss"
        onClick={() => {
          try { localStorage.setItem(KEY, 'done') } catch { /* fine */ }
          setShow(false)
        }}
      >
        ✕
      </button>
    </div>
  )
}
